import React from 'react'
import cn from 'classnames'
import Link from 'next/link'
import { DataAttributes } from './ChessContent'

import styles from '@corratech/pylot-custom-widgets/ChessContent/ChessContent.module.scss'

const ChessContentItem = (props: DataAttributes): React.ReactElement => {
    const {
        appearance,
        image,
        top_heading,
        heading,
        content,
        show_button,
        button_text,
        button_background_color,
        button_color,
        button_link
    } = props
    const isDefaultAligned = appearance === 'default'

    return (
        <div
            className={cn(styles['chess-content-item-wrapper'], {
                [styles['chess-content-item-right']]: !isDefaultAligned
            })}
        >
            <div
                className={cn(styles['chess-content-item'], {
                    [styles['chess-content-item-shrinked']]: !isDefaultAligned
                })}
            >
                <div className={styles['chess-content-item-top-heading']}>
                    {top_heading}
                </div>
                <h3 className={styles['chess-content-item-heading']}>
                    {heading}
                </h3>
                <p className={styles['chess-content-item-paragraph']}>
                    {content}
                </p>
                {show_button && show_button !== 'false' && button_link && (
                    <div className={styles['chess-button-wrapper']}>
                        <Link href={button_link} passHref>
                            <a className="btn-secondary">{button_text}</a>
                        </Link>
                    </div>
                )}
            </div>
            <div className={styles['chess-content-image-wrapper']}>
                <img src={image} alt={heading || ''} loading="lazy" />
            </div>
        </div>
    )
}

export default ChessContentItem
